<div class="wrapper shadowed">
    <ng-container
        *ngIf="((suiviId > 0 && detailAppel.id_sav_suivi) || (suiviId < 0)) && listTechniciensSav && people; else spinner">
        <div class="call-rapport">
            <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
                <div class="row">
                    <div class="btn-container col-12 col-lg-2 col-xl-1">
                        <button class="btn btn-success" type="submit">Enregistrer</button>
                        <!-- <button class="btn btn-danger" type="button">Supprimer</button> -->
                    </div>
                    <div class="col-12 col-lg-3 col-xl-2">
                        <ng-container *ngIf="confirmMessage!=''">
                            <p class="ok" *ngIf="confirmMessage=='Enregistrement réussi'">{{confirmMessage}}</p>
                            <p class="nok" *ngIf="confirmMessage=='Enregistrement échoué'">{{confirmMessage}}</p>
                        </ng-container>
                    </div>
                </div>

                <div *ngIf="suiviId > 0">
                    <h5>Validation du rapport</h5>
                    <p *ngIf="callGmao">
                        Rapport
                        <ng-container *ngIf="callGmao.call_state"><strong class="ok">OK</strong></ng-container>
                        <ng-container *ngIf="!callGmao.call_state"><strong class="nok">NOK</strong></ng-container>
                        par <b>{{callGmao.user_login}}</b> le {{getNiceDate(callGmao.state_time)}}
                    </p>
                    <div class="ok-nok" *ngIf="!callGmao || !callGmao.call_state">
                        <button class="btn btn-success" (click)="submitValidation(true)" type="button">Rapport
                            OK</button>
                        <button class="btn btn-danger" (click)="submitValidation(false)" type="button">Rapport
                            NOK</button>
                    </div>
                </div>
                <div class="form-container">
                    <h5>Intervenants Adial</h5>
                    <div class="row tech">
                        <ng-container *ngFor=" let tech of listTechniciensSav">
                            <div class="form-check col-6 col-lg-4 col-xl-2">
                                <input type="checkbox" class="form-check-input" id="tech.ID_PERSONNE"
                                    [ngModel]="checkTech(tech.ID_PERSONNE)" [name]="tech.ID_PERSONNE.toString()">
                                <label for="tech.ID_PERSONNE" class="form-check-label tech-label">{{tech.PRENOM}}
                                    {{tech.NOM}}</label>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <hr>
                <div class="form-container">
                    <h5>Identification de l'appel</h5>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label for="interlocuteur">Interlocuteur</label>
                                <mat-select [(value)]="selectedPersonne" name="interlocuteur"
                                    (selectionChange)="getPerson($event)">
                                    <input (keyup)="onKey($event)" placeholder="Chercher..." class="form-control">
                                    <mat-option *ngFor="let person of filteredPeople" [value]="person">
                                        {{person.prenom_nom}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <ng-container *ngIf="installation">
                                <ng-container *ngFor="let person of peopleInstal">
                                    <button class="btn btn-outline-dark" (click)="selectPerson(person.id_personne)"
                                        type="button">{{person.nom_personne}}</button>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <!-- TODO : sélection de la personne au clic sur le bouton -->
                    <!-- INFO : choix simple -->
                </div>
                <hr>
                <div class="form-container">
                    <h5>Facturation</h5>
                    <div class="row">
                        <div class="col-md-7 col-12">
                            <div class="form-group">
                                <label for="callDate">Date d'appel</label>
                                <input type="datetime-local" class="form-control" id="callDate" name="callDate"
                                    [ngModel]="dateIntervention">
                            </div>
                            <select name="duree" id="duree" class="form-control form-select"
                                [ngModel]="detailAppel.actions ? detailAppel.duree : 0">
                                <option selected value="0">Durée de l'appel</option>
                                <option value="5">5 minutes</option>
                                <option value="10">10 minutes</option>
                                <option value="15">15 minutes</option>
                                <option value="20">20 minutes</option>
                                <option value="25">25 minutes</option>
                                <option value="30">30 minutes</option>
                                <option value="35">35 minutes</option>
                                <option value="40">40 minutes</option>
                                <option value="45">45 minutes</option>
                                <option value="50">50 minutes</option>
                                <option value="55">55 minutes</option>
                                <option value="60">1 heure</option>
                                <option value="90">1 heure 30</option>
                                <option value="120">2 heures</option>
                                <option value="180">3 heures</option>
                            </select>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="termine" name="termine"
                                    [ngModel]="isTermine()">
                                <label for="termine" class="form-check-label">Terminé</label>
                            </div>
                            <ng-container *ngIf="contrat">
                                <p class="w-100">Contrat SAV de l'installation : <span
                                        [className]="contrat.id_contrat_sav > 0 ? 'ok' : 'nok' ">{{ contrat.nom_contrat
                                        }}</span>
                                </p>
                            </ng-container>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="facturable" name="facturable"
                                    [ngModel]="isFacturable()">
                                <label for="facturable" class="form-check-label">Facturable</label>
                            </div>
                        </div>
                        <div class="col-md-5 col-12">
                            <div class="form-froup">
                                <label for="numFacture">Numéro de facture</label>
                                <input type="text" class="form-control" id="numFacture" name="numFacture"
                                    [ngModel]="detailAppel.actions ? detailAppel.numero_facture : '' ">
                            </div>
                            <div class="form-group">
                                <label for="commentaire">Commentaire</label>
                                <textarea name="commentaire" id="commentaire" rows="3" class="form-control"
                                    [ngModel]="detailAppel.actions ? detailAppel.commentaires_facturation : '' "></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="form-container">
                    <h5>Détails de l'appel</h5>
                    <div class="action">
                        <!-- TODO : Bonus Sélection de l'action [hotline], [SAV], [MES], ... -->
                        <!-- TODO : Choix du/des codes défaut : [PC13], ... -->
                        <div class="form-group">
                            <label for="title">Titre</label>
                            <input type="text" class="form-control" id="title" placeholder="Titre de l'intervention"
                                name="title" [ngModel]="detailAppel.actions ? detailAppel.actions[0].nom_action : ''">

                        </div>
                        <div class="form-group">
                            <label for="description">Description</label>
                            <textarea id="description" rows="5" class="form-control" name="description"
                                [ngModel]="detailAppel.actions ? detailAppel.actions[0].descriptif : '' "></textarea>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="interAPrevoir" name="interAprevoir"
                                [ngModel]="detailAppel.actions ? detailAppel.actions[0].deplacement_to_do : '' ">
                            <label for="interAPrevoir" class="form-check-label">Intervention à prévoir</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="interEffectuee" name="interEffectuee"
                                [ngModel]="detailAppel.actions ? detailAppel.actions[0].deplacement_done : '' ">
                            <label for="interEffectuee" class="form-check-label">Intervention sur place
                                effectuée</label>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-template #spinner>
        <app-gmao-spinner></app-gmao-spinner>
    </ng-template>
</div>